"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.messageBuilder = void 0;
/**
 * logMsgBuilder to build a nicely formatted message
 */
const messageBuilder = (params) => {
    const { source, destination, outgoing, type, message, request, response, traceId } = params;
    const xrayTraceId = traceId ? `[${traceId}]` : '';
    const sourceDestination = source && destination ? `[${source}] -> [${destination}]` : '';
    const outgoingCall = outgoing ? '[outgoing]' : '';
    const typeCheck = type ? `[${type}]` : '';
    const requestCheck = request ? `[${request}]` : '';
    const responseCheck = response ? `[${response}]` : '';
    const str = `${sourceDestination} ${xrayTraceId} ${outgoingCall} ${typeCheck} [${message}] ${requestCheck} ${responseCheck}`;
    return str.replace(/  +/g, ' ');
};
exports.messageBuilder = messageBuilder;
//# sourceMappingURL=index.js.map